export const GET_USER_DATA = 'lk/user-data'

